/** @jsxImportSource @emotion/react */
import { Icon } from '@ssmm/ui';
import { Button } from 'components/landing/ui';
import { arrowRight } from 'components/landing/ui/icons';
import { Link as RouterLink } from 'react-router-dom';

import about1x from '../../images/about-service-in-two-minutes.png';
import about2x from '../../images/about-service-in-two-minutes@2x.png';
import about3x from '../../images/about-service-in-two-minutes@3x.png';
import arrow from '../../images/s1-arrow.svg';

const TryForFree = ({ openVideo }) => (
  <div
    css={{
      alignItems: 'center',
      flexWrap: 'wrap',
      justifyContent: 'center',
      width: '100%',
      '@media (min-width:768px)': { justifyContent: 'space-between' },
    }}
  >
    <div
      css={{
        position: 'relative',
        alignItems: 'center',
        '@media (min-width:992px)': { paddingBottom: 50, flexGrow: 1 },
      }}
    >
      <Icon
        onClick={() => openVideo('about')}
        svg='
    <svg width="70" height="71" viewBox="0 0 70 71" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="60.1641"
        y="60.79"
        width="50"
        height="50"
        rx="25"
        transform="rotate(-180 60.1641 60.79)"
        fill="#63C67A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.2552 30.1556C30.0887 30.0659 29.8867 30.1866 29.8867 30.3757V41.2045C29.8867 41.3937 30.0887 41.5143 30.2552 41.4246L40.3105 36.0102C40.4858 35.9158 40.4858 35.6644 40.3105 35.57L30.2552 30.1556ZM28.3867 30.3757C28.3867 29.0516 29.8005 28.2071 30.9664 28.8349L41.0217 34.2493C42.2488 34.91 42.2488 36.6702 41.0217 37.3309L30.9664 42.7453C29.8005 43.3731 28.3867 42.5287 28.3867 41.2045V30.3757Z"
        fill="white"
      />
      <circle cx="35" cy="35.6128" r="34.5" stroke="#63C67A" />
    </svg>'
        css={{ cursor: 'pointer', marginRight: 20 }}
      />

      {/* <RouterLink to="/lk" target="_blank">
      </RouterLink> */}
      <Button
        type="blue"
        icon={arrowRight}
        onClick={() => window.open('https://vk-boss-light.web.app/guide', '_blank')}
      >
        Попробовать бесплатно
      </Button>

      <img
        src={arrow}
        css={{
          position: 'absolute',
          display: 'none',
          bottom: -91,
          right: -30,

          '@media (min-width:992px)': { display: 'block' },
          '@media (min-width:1366px)': { right: 0, bottom: -111, width: 278 },
        }}
      />
    </div>

    <div
      onClick={() => openVideo('about')}
      css={{
        position: 'relative',
        cursor: 'pointer',
        display: 'none',
        borderRadius: 20,
        zIndex: 1,
        ':after': {
          background: '#3D8EE3',
          borderRadius: 20,
          animation: 'pulsate-2 1.5s ease-out',
          animationIterationCount: 'infinite',
          opacity: 0.0,
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        },
        '@media (min-width:768px)': { display: 'block' },
      }}
    >
      <img
        srcSet={`${about1x} 1x, ${about2x} 2x, ${about3x} 3x`}
        css={{
          width: '100%',
          borderRadius: 20,
        }}
      />
    </div>
  </div>
);

export default TryForFree;
